import { processError } from '../utils/processError';
import { PublishedTests, TestDetails } from '../contexts/TestContext';
import api from './index';
import { CandidateData, CandidateDetails } from '../contexts/CandidateContext';

const service = 'TestService';

interface TestCreationDetails {
  subjectId: number;
  code: string;
  description: string;
  categoryId: number;
  institution: number;
}

export interface Category {
  id: number;
  institutionId: number;
  name: string;
}
export interface Period {
  periodId: number;
  period: string;
  candidateCount: number;
  institutionId: number;
  startDate: null | string;
  endDate: null | string;
}
export interface Subject extends Category {
  category: string;
  categoryId: number;
  code: string;
}

export interface AssignData {
  testIds: Array<number>;
  periodId: number;
}

export interface IExamCategory {
  categoryId: number;
  category: string;
  period: string;
  periodId: number;
  candidateCount: number;
}

// MUTATIONS

//questions
const createTest = async (details: TestCreationDetails) => {
  try {
    const response = await api.post(`/${service}/api/Test/Create`, details);
    return response.data;
  } catch (e) {
    processError(e);
  }
};
const assignTest = async (assignData: AssignData) => {
  try {
    const response = await api.post(`/${service}/api/Test/Assign`, assignData);
    return response.data;
  } catch (e) {
    processError(e);
  }
};
const publishTest = async ([testId, details]: Array<number | TestDetails>) => {
  try {
    const response = await api.post(
      `/${service}/api/Test/Details/${testId}`,
      details
    );
    return response.data;
  } catch (e) {
    processError(e);
  }
};
const uploadQuestionFile = async (formData: FormData) => {
  try {
    const response = await api.post(
      `/${service}/api/Test/Upload/Question`,
      formData
    );
    return response.data;
  } catch (e) {
    processError(e);
  }
};

//candidates
const uploadCandidateFile = async (formData: FormData) => {
  try {
    const response = await api.post(
      `/${service}/api/Test/Upload/Candidate`,
      formData
    );
    return response.data;
  } catch (e) {
    processError(e);
  }
};
const publishCandidates = async (candidateData: CandidateDetails) => {
  try {
    const response = await api.post(
      `/${service}/api/Test/Upload/Candidate/Confirm`,
      candidateData
    );
    return response.data;
  } catch (e) {
    processError(e);
  }
};

// QUERIES

//tests
export const getPublishedTests = async (institutionId: number, sort?: string, status?: string ) => {
  const { data } = await api.get<{data: PublishedTests[]}>(`/${service}/api/Test/${institutionId}?sort=${sort}&status=${status}`);
  return data;
};

export const getTestCategories = async (institutionId: number) => {
  const { data } = await api.get(
    `/${service}/api/Test/Category?InstitutionId=${institutionId}`
  );
  return data;
};

export const getTestSubject = async (
  institutionId: number,
  categoryId: number
) => {
  const { data } = await api.get(
    `/${service}/api/Test/Subject?InstitutionId=${institutionId}&CategoryId=${categoryId}`
  );
  return data;
};

export const getTestPeriod = async (institutionId: number) => {
  const { data } = await api.get(
    `/${service}/api/Test/Period?InstitutionId=${institutionId}`
  );
  return data;
};

export const activateTest = async (testId: number) => {
  const { data } = await api.get(`/${service}/api/Test/Activate/${testId}`);
  return data;
};
export const deleteTest = async (testId: number) => {
  const { data } = await api.get(`/${service}/api/Test/Delete/${testId}`);
  return data;
};
export const suspendTest = async (testId: number) => {
  const { data } = await api.get(`/${service}/api/Test/Suspend/${testId}`);
  return data;  
};

//candidates
export const getCandidateSummary = async (institutionId: number) => {
  const { data } = await api.get<{ data: IExamCategory[] }>(
    `/${service}/api/Test/Candidate/Summary?InstitutionId=${institutionId}`
  );
  return data;
};
export const getCandidateByCategory = async (
  institutionId: number,
  periodId: number,
  categoryId: number
) => {
  const { data } = await api.get<{data: CandidateData[]}>(
    `/${service}/api/Test/Candidates?InstitutionId=${institutionId}&Period=${periodId}&category=${categoryId}`
  );
  return data;
};

const getProctoredImages = async (
  candidateId?: number,
  testId?: number,
  page?: number,
  pageSize?: number
) => {
  const params = { testId, candidateId, page, pageSize };
  try {
    const { data } = await api.get(`/testservice/api/Test/RetrieveImages`, {
      params,
    });
    return data;
  } catch (e) {
    processError(e);
  }
};

const getFileStatistics = async (candidateId: number, testId: number) => {
  try {
    const { data } = await api.get(
      `/testservice/api/Test/candidate/file-stats?candidateId=${candidateId}&testId=${testId}`
    );
    return data;
  } catch (e) {
    processError(e);
  }
}

const testApi = {
  createTest,
  assignTest,
  publishTest,
  publishCandidates,
  uploadQuestionFile,
  uploadCandidateFile,
  getPublishedTests,
  getTestCategories,
  getTestPeriod,
  getTestSubject,
  activateTest,
  deleteTest,
  suspendTest,
  getCandidateSummary,
  getCandidateByCategory,
  getProctoredImages,
  getFileStatistics,
};

export default testApi;
